import _ from 'underscore';
import { ProjectionGridBaseColumn } from '@bingads-webui/projection-grid-base-column';

export class BaseColumn extends ProjectionGridBaseColumn {
  constructor(options) {
    super(options);
    this.i18n = options.i18n;
  }

  // Override the default 'pickProperty' to pick multi properties.
  pickProperty(rowData) {
    const keys = _.union(
      // this.property.key may be a string or an array, need to convert it to an array
      _.flatten([this.property.key]),
      ['$total']
    );
    return _.pick(rowData, keys);
  }
}
